import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  removeWorkerAssociation,
  type RemoveWorkerAssociationRequest,
} from 'api/admin/dayforce/removeWorkerAssociation'
import { shiftDetailKey } from 'queries/shifts/keys'
import { dayforceKeys } from './keys'

export type RemoveWorkerAssociationMutationVariables =
  RemoveWorkerAssociationRequest & {
    shiftId?: number
  }

export const useRemoveWorkerAssociationMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      shiftId: _shiftId,
      ...request
    }: RemoveWorkerAssociationMutationVariables) =>
      removeWorkerAssociation(request),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: dayforceKeys.all,
      })
      if (variables.shiftId !== undefined) {
        await queryClient.invalidateQueries({
          queryKey: shiftDetailKey(variables.shiftId),
        })
      }
    },
  })
}
